import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FiltersItem } from '../../../models/shared/filters-item.model';

@Component({
    selector: 'app-filters-dropdown-item',
    templateUrl: './filters-dropdown-item.component.html',
    styleUrls: ['./filters-dropdown-item.component.scss'],
})
export class FiltersDropdownItemComponent {
    @Input() title: string;
    @Input() collapseId: string;
    @Input() options: FiltersItem[];
    @Input() isCommunity: boolean;
    @Input() checkAllEnabled: boolean = false;
    @Input() checkAllLabel: string;
    @Input() projectsDirectory: boolean;

    get checkAllStatus(): boolean {
        return this.options.length == this.selectedOptions.length;
    }

    get visibleOptions(): FiltersItem[] {
        return this.options.filter((option) => option.checked || option.visible);
    }

    get selectedOptions(): FiltersItem[] {
        return this.options.filter((option) => option.checked);
    }

    @Output() selectionChange = new EventEmitter<FiltersItem[]>();
    @Output() checkAllSelectionChange = new EventEmitter<boolean>();

    constructor() {}

    onSearchTextChanged(searchText: string) {
        this.options.forEach((option) => {
            option.visible = !searchText || option.value.trim().toLowerCase().includes(searchText.trim().toLowerCase());
        });
    }

    onChange(option: FiltersItem) {
        option.checked ? option.check() : option.uncheck();
        this.selectionChange.emit(this.selectedOptions);
    }

    onCheckAll(checked: boolean) {
        this.options.forEach((option) => (checked ? option.check() : option.uncheck()));

        this.selectionChange.emit(this.selectedOptions);
        this.checkAllSelectionChange.emit(checked);
    }
}
